import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

import {
  InspectorConsoleLine,
  InspectorConsoleSource,
} from 'ev-common/Inspector/InspectorTypes';

type InspectorData = {
  consoleLines: InspectorConsoleLine[];
  consoleEnabled: boolean;
  consoleLogErrors: boolean;
  attachConsoleLog: boolean;
  lastSearch: string;
  groupFeaturesSettings: boolean;
};
const globalErrorInitialState: InspectorData = {
  consoleLines: [],
  consoleEnabled: false,
  consoleLogErrors: false,
  attachConsoleLog: false,
  groupFeaturesSettings: true,
  lastSearch: '',
};

export const inspectorSlice = createSlice({
  name: 'inspectorData',
  initialState: globalErrorInitialState,
  reducers: {
    toggleAttachConsoleLog(state) {
      state.attachConsoleLog = !state.attachConsoleLog;
    },
    toggleConsole(state) {
      state.consoleEnabled = !state.consoleEnabled;
    },
    toggleConsoleLogErrors(state) {
      state.consoleLogErrors = !state.consoleLogErrors;
    },
    toggleGroupFeaturesSettings(state) {
      state.groupFeaturesSettings = !state.groupFeaturesSettings;
    },
    setLastSearch(state, { payload: search }: PayloadAction<string>) {
      state.lastSearch = search;
    },
    appendConsoleLine(
      state,
      { payload: consoleLine }: PayloadAction<InspectorConsoleLine>,
    ) {
      if (
        consoleLine.source === InspectorConsoleSource.Inspector ||
        state.consoleLogErrors
      ) {
        state.consoleLines.splice(0, 0, {
          ...consoleLine,
          timestampISO:
            consoleLine.timestampISO ?? DateTime.local().toFormat('HH:mm:ss'),
        });
      }
    },
  },
});
